"use client";
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAuth } from "@mirats/mirats-auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";

interface UserData {
  _id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  name?: string;
  gasUserId?: string;
}

interface AppContextType {
  userData: UserData | null;
}

const AppContext = createContext<AppContextType | null>(null);

export const useGlobalContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useGlobalContext must be used within a GlobalContext provider');
  }
  return context;
};

interface GlobalContextProps {
  children: React.ReactNode;
}

const GlobalContext: React.FC<GlobalContextProps> = ({ children }) => {
  const [userData, setUserData] = useState<UserData | null>(null);

        const getUserData = async () => {
        try {
          console.log('Getting user data from Mirats Auth...');
          const user = await getAuth();
          console.log('Mirats Auth response:', user);
          if (user && user?.currentUser?._id) {
            console.log('Setting user data:', user.currentUser);
            // Store user data in localStorage for API client
            const userDataForStorage = {
              email: user.currentUser.email,
              name: user.currentUser.firstName && user.currentUser.lastName 
                ? `${user.currentUser.firstName} ${user.currentUser.lastName}`
                : user.currentUser.firstName || user.currentUser.email || 'User',
              gasUserId: user.currentUser._id,
            };
            console.log('GlobalContext: Storing user data in localStorage:', userDataForStorage);
            localStorage.setItem('userData', JSON.stringify(userDataForStorage));
            setUserData(user?.currentUser);
            return;
          } else {
            console.log('No valid user data found');
          }
        } catch (error) {
          console.log('Error getting user data:', error);
        }
      };

  useEffect(() => {
    if (!Object.keys(userData || {}).length) {
      getUserData();
    }
  }, [userData?._id]);

  return (
    <AppContext.Provider value={{ userData }}>
      <ProtectedRoute>
        {children}
      </ProtectedRoute>
    </AppContext.Provider>
  );
};

export default GlobalContext; 